import React from "react";
import styles from "./MillionPrize.module.scss";
import jellyMan from "../../img/millionPrize/jellyMan.png";
import bubble from "../../img/millionPrize/bubble.png";
import redBall from "../../img/millionPrize/redBall.png";
import blueBall from "../../img/millionPrize/blueBall.png";
import whiteIcon from "../../img/millionPrize/whiteIcon.png";
const MillionPrize = ({ millionPrizeRef }) => {
  return (
    <div className={styles.container} ref={millionPrizeRef}>
      <div className={styles.contents_box}>
        <h1 className={styles.million_prize_title}>
          <span data-content="$1,000,000">$1,000,000</span>{" "}
          <span data-content="PRIZE!">PRIZE!</span>
        </h1>
        <a
          href="https://dashboard.mondayoff.me"
          target="_blank"
          rel="noreferrer"
        >
          Join Our Dashboard
        </a>
        <img className={styles.top_bubble} src={bubble} alt="bubble" />
        <img className={styles.bellow_bubble} src={bubble} alt="bubble" />
        <img className={styles.jelly_man} src={jellyMan} alt="jellyMan" />
        <img className={styles.redball} src={redBall} alt="redBall" />
        <img className={styles.blueball} src={blueBall} alt="blueBall" />
        <img className={styles.white_icon} src={whiteIcon} alt="icon" />
      </div>
    </div>
  );
};

export default MillionPrize;
